export default __webpack_public_path__ + "static/media/tomato.36e8f700.png";